import React, { Component } from "react";

export default class InvalidToken extends Component {
  componentDidMount() {
    // eslint-disable-next-line no-undef
    grecaptcha.render(document.getElementById("recaptchaInvalidToken"), {
      sitekey: "6LdD7SgTAAAAALjVAm80uYL-CKmPlF1Wwt0CYjv4",
      callback: this.props.setRecaptcha,
    });
  }
  render() {
    const {
      userInfo,
      setEmailAddress,
      initForgotPassword,
      customerInfo,
    } = this.props;

    let pathArray = location.href.split("/");
    let protocol = pathArray[0];
    let host = pathArray[2];
    let url = protocol + "//" + host + "/forgot-password/";
    return (
      <div className={userInfo.get("displayLoading") ? "hide" : ""}>
        <h1>Invalid Link</h1>
        <p style={{ color: "black" }}>
          {" "}
          Your link has expired. Would you like us to send you another email
          with a valid link?
        </p>
        <label className="label-header">Email</label>
        <input
          type="text"
          onChange={(e) => setEmailAddress(e)}
          className="cc-input mar-b-10"
        />
        <div id="recaptchaInvalidToken" className="mar-b-10 mar-t-10">
          {" "}
        </div>
        <button
          onClick={() =>
            initForgotPassword(
              userInfo.get("resetPasswordEmailAddress"),
              customerInfo.get("recaptchaCode"),
              url
            )
          }
          className="blue-btn"
        >
          Send new link
        </button>
      </div>
    );
  }
}
